import { useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CloseFeatureAnnouncement,
  FeatureAnnouncementsActiveApi,
  ShowFeatureAnnouncement,
} from "store/slices/featureAnnouncementSlice";
import { parseAnnouncements, pickNextAnnouncement } from "pages/featureAnnouncement/featureAnnouncementStorage";
import FeatureAnnouncementModal from "./FeatureAnnouncementModal";

/** Re-check while popup is closed (aligns with 1 min admin interval). */
const POLL_MS = 30 * 1000;

const FeatureAnnouncementManager = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const userId = auth.user?.id;
  const token = auth.token;
  const isOpen = useSelector((state) => state.featureAnnouncement.isOpen);
  const isOpenRef = useRef(isOpen);
  isOpenRef.current = isOpen;

  const loadAndMaybeShow = useCallback(() => {
    if (!token || !userId) {
      return;
    }

    dispatch(FeatureAnnouncementsActiveApi()).then((action) => {
      if (action.meta.requestStatus !== "fulfilled") {
        return;
      }

      const list = parseAnnouncements(action.payload);
      const next = pickNextAnnouncement(list, userId);

      if (!next) {
        if (isOpenRef.current) {
          dispatch(CloseFeatureAnnouncement());
        }
        return;
      }

      if (isOpenRef.current) {
        return;
      }

      dispatch(ShowFeatureAnnouncement(next));
    });
  }, [dispatch, token, userId]);

  useEffect(() => {
    if (!token || !userId) {
      return undefined;
    }

    loadAndMaybeShow();
    const intervalId = window.setInterval(loadAndMaybeShow, POLL_MS);

    return () => window.clearInterval(intervalId);
  }, [token, userId, loadAndMaybeShow]);

  return <FeatureAnnouncementModal />;
};

export default FeatureAnnouncementManager;
